import { Country } from '~/Api/Country';

export enum ErrorCode {
	atMostOneProductPerCountry = 'arab-emirates-max-price-calculation-requires-at-most-one-product-for-each-country',
	cannotChangeSettingsForNonMemberProducts = 'arab-emirates-max-price-calculation-cannot-change-settings-for-non-member-products',
	illegalPriceTypeSelected = 'arab-emirates-max-price-calculation-illegal-price-type-selected',
	productSettingsMissing = 'arab-emirates-max-price-calculation-required-product-settings-is-missing',
	referenceCountryProductMissing = 'arab-emirates-max-price-calculation-requires-at-least-one-reference-country-product',
	referenceSettingsMissing = 'arab-emirates-max-price-calculation-requires-reference-settings',
}

export class Error {
	public constructor(
		public code: ErrorCode,
		public productId: string | null,
		public missingSettings: Set<string>,
		public duplicateCountries: Country[]
	) {}
}
